import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
});

export const Content = styled('div')({
    padding: '24px 16px',
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});
